"use client";

import Image from "next/image";
import { useState } from "react";
import { PlayerIcon } from "./icon";

export function PlayerAvatarContent({
  displayName,
  avatarUrl,
}: {
  displayName?: string;
  avatarUrl?: string | null;
}) {
  const [failedUrl, setFailedUrl] = useState<string>();
  if (avatarUrl && avatarUrl !== failedUrl)
    return (
      <Image
        className="player-avatar-image"
        src={avatarUrl}
        alt=""
        width={96}
        height={96}
        unoptimized
        onError={() => setFailedUrl(avatarUrl)}
      />
    );
  return Array.from(displayName ?? "")[0] || <PlayerIcon name="profile" />;
}
